export default __webpack_public_path__ + "1a532b292f8d25671ef739ef40816ecd.png";